{
  "alert": "Alerta",
  "dismiss": "Descartar"
}
